import environment from "environment";
import HttpErrorResponseModel from "models/HttpErrorResponseModel";
import EffectUtility from "utilities/EffectUtility";
import AppuntamentoModel from "./models/AppuntamentoModel";
import GetAppuntamentiModel from "./models/GetAppuntamentiModel";

export interface ISaveAppuntamentoRequest {
    idAppointment?: number;
    object?: string;
    text?: string;
    appointmentDate?: string;
    startTime?: string;
    endTime?: string;
    cityCode?: string;
    addressTypeCode?: string;
    address?: string;
    civicNumber?: string;
}

export default class AgendaEffect {
    public static async salvaAppuntamento(
        request: ISaveAppuntamentoRequest
    ): Promise<AppuntamentoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveAppointment;
        return EffectUtility.postToModel<AppuntamentoModel>(AppuntamentoModel, endpoint, request);
    }

    public static async updateAppuntamento(
        request: ISaveAppuntamentoRequest
    ): Promise<AppuntamentoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveAppointment;
        return EffectUtility.postToModel<AppuntamentoModel>(AppuntamentoModel, endpoint, request);
    }

    public static async getAppuntamenti(data: string): Promise<GetAppuntamentiModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getAppointment;
        return EffectUtility.getToModel<GetAppuntamentiModel>(GetAppuntamentiModel, endpoint, {
            date: data,
        });
    }

    public static async deleteAppuntamento(id: number): Promise<GetAppuntamentiModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.deleteAppointment + `?idAppointment=${id}`;
        return EffectUtility.postToModel<GetAppuntamentiModel>(GetAppuntamentiModel, endpoint);
    }
}
